/**
 * @generated SignedSource<<bb741c8505a6fc90c738aaf0c67864ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type requestCareQuery$variables = {
  insuranceid: string;
  queryEnd: any;
  queryStart: any;
  requesttype?: ReadonlyArray<number> | null | undefined;
};
export type requestCareQuery$data = {
  readonly insurance_request_log_connection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly aiconsultdetailid: number | null | undefined;
        readonly caredetailid: number | null | undefined;
        readonly created_at: any | null | undefined;
        readonly id: string;
        readonly insuranceid: string;
        readonly recipient: {
          readonly email: string | null | undefined;
          readonly id: string;
          readonly imageurl: string | null | undefined;
          readonly last_seen: any;
          readonly name: string;
        } | null | undefined;
        readonly recipientid: string | null | undefined;
        readonly request_care_details: {
          readonly addressdetail: string | null | undefined;
          readonly created_at: any;
          readonly desiredenddate: any;
          readonly desiredstartdate: any;
          readonly excutedate: any | null | undefined;
          readonly excuterid: string | null | undefined;
          readonly hospital: {
            readonly id: string;
            readonly images: ReadonlyArray<string> | null | undefined;
            readonly name: string | null | undefined;
          } | null | undefined;
          readonly hospitalid: number | null | undefined;
          readonly id: string;
          readonly otherrequirement: string | null | undefined;
          readonly patientname: string;
        } | null | undefined;
        readonly requeststatus: number;
        readonly requesttype: number;
      };
    }>;
  };
};
export type requestCareQuery = {
  response: requestCareQuery$data;
  variables: requestCareQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "insuranceid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryEnd"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryStart"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requesttype"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created_at",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_gte",
                "variableName": "queryStart"
              },
              {
                "kind": "Variable",
                "name": "_lte",
                "variableName": "queryEnd"
              }
            ],
            "kind": "ObjectValue",
            "name": "created_at"
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "insuranceid"
              }
            ],
            "kind": "ObjectValue",
            "name": "insuranceid"
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_in",
                "variableName": "requesttype"
              }
            ],
            "kind": "ObjectValue",
            "name": "requesttype"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "insurance_request_logConnection",
    "kind": "LinkedField",
    "name": "insurance_request_log_connection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "insurance_request_logEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "insurance_request_log",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "request_care_detail",
                "kind": "LinkedField",
                "name": "request_care_details",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "otherrequirement",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "patientname",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hospitalid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "excuterid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "excutedate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "desiredstartdate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "desiredenddate",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "addressdetail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "medical_center",
                    "kind": "LinkedField",
                    "name": "hospital",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "images",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "users",
                "kind": "LinkedField",
                "name": "recipient",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageurl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "last_seen",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requeststatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requesttype",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recipientid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "insuranceid",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "caredetailid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiconsultdetailid",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "requestCareQuery",
    "selections": (v7/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "requestCareQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "fea75e88d01a1061c8c36aab1208b334",
    "id": null,
    "metadata": {},
    "name": "requestCareQuery",
    "operationKind": "query",
    "text": "query requestCareQuery(\n  $requesttype: [Int!]\n  $insuranceid: String!\n  $queryStart: timestamptz!\n  $queryEnd: timestamptz!\n) {\n  insurance_request_log_connection(where: {requesttype: {_in: $requesttype}, insuranceid: {_eq: $insuranceid}, created_at: {_gte: $queryStart, _lte: $queryEnd}}) {\n    edges {\n      node {\n        request_care_details {\n          id\n          otherrequirement\n          patientname\n          hospitalid\n          excuterid\n          excutedate\n          desiredstartdate\n          desiredenddate\n          created_at\n          addressdetail\n          hospital {\n            id\n            images\n            name\n          }\n        }\n        recipient {\n          id\n          email\n          imageurl\n          last_seen\n          name\n        }\n        requeststatus\n        requesttype\n        recipientid\n        insuranceid\n        id\n        created_at\n        caredetailid\n        aiconsultdetailid\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ec516f3e4eeeed0be1e94faaa7836b2";

export default node;
